import(/* webpackMode: "eager" */ "/codebuild/output/src3530848455/src/dharmayana-website/src/app/(pages)/layout.tsx");
